import { fmtHours, money } from "./api";

// FORMA DE COBRANÇA da ficha: por HORA (padrão/histórico) ou por DIA.
// A unidade define APENAS como o `valor_total` foi calculado — faturamento,
// parcelamento, PIX, boleto, misto e entrada+saldo continuam usando só o
// valor_total e nunca olham a unidade.
//
// Helpers compartilhados entre a Ficha de Serviço e as listagens do
// Faturamento, para que a MESMA ficha não apareça com rótulos diferentes
// em telas diferentes (a tabela de fichas a faturar mostrava uma coluna
// fixa "Valor hora", que numa ficha por diária exibia R$ 0,00 — correto no
// total, enganoso na leitura).
export const UNIDADE_HORA = "hora";
export const UNIDADE_DIA = "dia";

/** Unidade EFETIVA. Ficha legada (campo ausente) é "hora" — mesma regra do
 *  backend (ticket_unidade_cobranca), nunca exige migração de dados. */
export const unidadeDe = (o) => (o?.unidade_cobranca === UNIDADE_DIA ? UNIDADE_DIA : UNIDADE_HORA);

export const isPorDia = (o) => unidadeDe(o) === UNIDADE_DIA;

/** Quantidade de diárias em pt-BR: "5 dias", "0,5 dias", "1 dia". */
export function fmtDias(dias) {
  const valor = Number(dias) || 0;
  const texto = valor.toLocaleString("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  return `${texto} ${valor === 1 ? "dia" : "dias"}`;
}

/** Quantidade FATURÁVEL na unidade da ficha: "12:00h" ou "2 dias". */
export function qtdFaturavel(t) {
  return isPorDia(t) ? fmtDias(t?.quantidade_dias) : fmtHours(t?.horas_faturaveis);
}

/** Valor UNITÁRIO na unidade da ficha: "R$ 130,00/h" ou "R$ 250,00/dia".
 *  Nunca devolve vazio — ficha sem valor unitário informado mostra R$ 0,00
 *  com o sufixo certo, em vez de parecer uma ficha por hora zerada. */
export function valorUnitario(t) {
  return isPorDia(t)
    ? `${money(t?.valor_dia || 0)}/dia`
    : `${money(t?.valor_hora || 0)}/h`;
}
